import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { handleHousingDeposits, validDecimalAndLength } from '../../ModificationsUtils';

export const Private2BedroomDepositAmount = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();
  const private2BedRoomDepositAmount = 'private2BedRoomDepositAmount';
  const private2BedRoomDepositAmountW: number = useWatch({ name: private2BedRoomDepositAmount });
  const handleChange = (value: string) => {
    setValue(private2BedRoomDepositAmount, value);
    const updateValues = handleHousingDeposits(getValues('deposits'), 2, value ? value : '0', 'amount');
    setValue('deposits', updateValues);
  };
  return (
    <Controller
      control={control}
      name={private2BedRoomDepositAmount}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(private2BedRoomDepositAmount) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              handleChange(validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: private2BedRoomDepositAmountW ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="private2BedRoomDepositAmount"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.private2BedRoomDepositAmount')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
